// src/utils/slugify.js
export const slugify = text => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

// src/utils/readingTime.js
export const calculateReadingTime = (content, wordsPerMinute = 200) => {
  const text = content.replace(/<[^>]*>/g, '');
  const words = text.trim().split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  return Math.max(1, minutes);
};

// src/utils/sanitize.js
import DOMPurify from 'dompurify';

export const sanitizeHTML = html => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'br',
      'hr',
      'strong',
      'b',
      'em',
      'i',
      'u',
      'strike',
      'a',
      'img',
      'ul',
      'ol',
      'li',
      'blockquote',
      'pre',
      'code',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td',
      'div',
      'span',
    ],
    ALLOWED_ATTR: [
      'href',
      'src',
      'alt',
      'title',
      'class',
      'id',
      'target',
      'rel',
    ],
  });
};

// src/utils/seoHelpers.js
export const generateMetaDescription = (content, maxLength = 160) => {
  const text = content.replace(/<[^>]*>/g, '');
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

export const validateSlug = slug => {
  const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugRegex.test(slug);
};

// src/utils/validators.js
export const validateBlogData = data => {
  const errors = {};

  if (!data.title || data.title.trim().length === 0) {
    errors.title = 'Title is required';
  } else if (data.title.length > 200) {
    errors.title = 'Title must be less than 200 characters';
  }

  if (!data.content || data.content.trim().length === 0) {
    errors.content = 'Content is required';
  }

  if (!data.category) {
    errors.category = 'Category is required';
  }

  if (data.seoTitle && data.seoTitle.length > 60) {
    errors.seoTitle = 'SEO title should be less than 60 characters';
  }

  if (data.seoDescription && data.seoDescription.length > 160) {
    errors.seoDescription =
      'SEO description should be less than 160 characters';
  }

  return errors;
};
